export default {
  data: {
    certificate: null,
    course: null,
    user: null,
    shareEmails: null,
    shareDescription: '',
    showModal: false
  },

  computed: {
    shareName() { 
      if (this.user && this.course) 
        return this.user.full_name + ' has successfully completed an online offering of ' + this.course.name + ' on Kadenze';
      else
        return '';
    },

    shareableObj() {
      return {
        title: this.shareName, 
        description: null,
        share_url: this.user && this.user.share_link || null
      };
    }
  },

  methods: {
    bindData(data) {
      this.certificate = data;
      this.course = data.course;
      this.user = data.user;
    },

    emailCertificate(obj, emailArray) {
      // let url = Kadenze.Routes.share_certificate_path(this.certificate.code, {emails: emailArray});

      // let request = new Kadenze.AjaxRequest({
      //   url: url,
      //   method: 'POST'
      // });

      // request.done(function(data) {
        new Kadenze.Notice.success("This feature is not available for now.");
      // });

      // request.fail(function(xhr, textStatus, errorThrown) {
      //   new Kadenze.Notice.error(xhr.responseJSON);
      // });
    },

    areEmailsValid() {
      if (_.isEmpty(emails)) {
        return false;
      } else {
        return _.every(emails.split(','), function(email) {
          return (/^.+@.+\..+$/i).test(email);
        });
      }
    }

  },
  beforeMount() {
    this.course_id = this.$el.dataset.courseId;
  },
  mounted() {
    Kadenze.PaginationBinding.applyBindingsWithTextInput(this.surveyListing);
  }
};
